<template>
  <v-container>
    <p>{{ $t("Whether you are a school, leisure centre, sports club, gym, (the list is endless) we are well aware that lost property will be an issue, for which {brand} has a revolutionary solution", {brand: this.capitalizeFirstLetter(this.brand)}) }}. {{ $t("And it is completely") }} <span class="font-weight-black">{{ $t("FREE") }}</span> {{ $t("for organisations to use") }}.</p>

    <ul>
      <li>{{ $t("We solve your lost property problem") }}.</li>
      <li>{{ $t("A great way to reduce your environmental impact") }}.</li>
      <li><router-link
          :to="{ name: 'contact-us' }"
          exact
      >{{ $t('links.Contact us') }}</router-link> {{ $t("to explore our revenue generating opportunity") }}</li>
    </ul>
  </v-container>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "OrganisationsSummary",
  computed: {
    ...mapState({
      brand: state => state.brand,
brandName: state => state.brandName
    }),
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  }
}
</script>

<style scoped>

</style>
